// Requires all .js or .ts files in a require context
export default function requireAll(requireContext) {
  return requireContext.keys().map(requireContext);
}
